import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographySmallProps } from "../types";

function TypographySmall({
  as,
  asChild,
  className,
  ...props
}: TypographySmallProps) {
  const Component = resolveElement(asChild, as, "small");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.Small] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          ~text-xs/base
          font-body
          font-medium
          leading-none
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographySmall;
